import { SelectOption } from '../../shared/services/select/interfaces/SelectOption';
import { NewsLocation } from '../enums/NewsLocation';

export const newsLocationOptions: SelectOption[] = [
  { title: 'All', value: NewsLocation.All },
  { title: 'Private', value: NewsLocation.Private },
  { title: 'US', value: NewsLocation.US },
  { title: 'Non-US', value: NewsLocation.NonUS },
];
